module.exports = __webpack_public_path__ + "img/vip_tongpai.75de75fd.png";